module.exports = "<div [id]=\"chartDiv\" ></div> \n\n<!--style=\"width: 50%; height: 50%\"-->"